// ==============================
// 파일명 : src/constants/users/form.js
// 역할 : 유저 생성/수정 모달에서 사용하는 문구와
//         기본값, UID 관련 안내 문구를 중앙에서 관리
// 수정일 : 2025-10-14
// ==============================

import { DEFAULT_USER_TEMP_PASSWORD } from "./defaults"; // [수정-2025-10-14] 공통 임시 비밀번호 상수 재사용

export const USER_FORM_MODAL_TEXT = {
  titles: {
    add: "유저 추가", // [수정] 추가 모달 제목
    edit: "유저 수정", // [수정] 수정 모달 제목
  },
  labels: {
    name: "이름", // [수정] 이름 입력 필드 라벨
    email: "이메일", // [수정] 이메일 입력 필드 라벨
    password: "비밀번호", // [수정] 비밀번호 입력 필드 라벨
    packs: "보유 팩", // [수정] 보유 팩 섹션 라벨
    authUid: "인증 UID", // [수정] Firebase Authentication UID 표시 라벨
  },
  placeholders: {
    name: "이름", // [수정] 이름 입력 플레이스홀더
    email: "이메일", // [수정] 이메일 입력 플레이스홀더
    passwordAddPrefix: "기본값: ", // [수정] 추가 시 비밀번호 안내 접두어
    passwordEdit: "변경 시에만 입력", // [수정] 수정 시 안내 문구
    authUidAdd:
      "관리자에서 새 유저를 만들면 UID가 자동으로 생성되며, Firebase와 Firestore에 같은 값으로 저장됩니다.", // [수정] 추가 모드 UID 안내 문장
    authUidEdit:
      "이미 가입된 유저는 UID가 고정되어 있으며 변경할 수 없습니다. 필요하면 값을 복사해 다른 시스템과 매핑하세요.", // [수정] 수정 모드 UID 안내 문장
  },
  guides: {
    passwordEdit: "비밀번호를 변경하지 않으려면 비워 두세요.", // [수정] 수정 안내 문장
    authUid: "웹/앱 회원가입 시 발급된 Firebase UID를 입력하면 문서 ID가 동일해집니다.", // [수정] UID 안내 문장
  },
  actions: {
    cancel: "취소", // [수정] 취소 버튼 라벨
    save: "저장", // [수정] 저장 버튼 라벨
    copyUid: "UID 복사", // [수정] UID 복사 버튼 라벨
  },
  feedback: {
    uidCopied: "UID를 복사했어요.", // [수정] 복사 성공 메시지
    uidCopyFailed: "복사에 실패했어요. 직접 드래그해서 복사해주세요.", // [수정] 복사 실패 메시지
  },
};

export const USER_FORM_DEFAULT_PASSWORD = DEFAULT_USER_TEMP_PASSWORD; // [수정-2025-10-14] Firebase 정책을 충족하는 공통 임시 비밀번호 노출